// Shared labels + colors for the 5 customer-facing notification groups. Raw NotificationLog
// types are merged into these groups for display (check-in + check-out → "Status changed"), so
// the stacked charts and the insights breakdown stay consistent.
export const GROUP_META = {
  booked: { label: 'Booked', color: '#007BFF' },
  queue_position: { label: 'Queue position', color: '#00C4CC' },
  reminder: { label: 'Reminder', color: '#7E57C2' },
  invite: { label: 'Link sent', color: '#EF6C00' },
  status: { label: 'Status changed', color: '#2E7D32' },
};
export const GROUP_ORDER = ['booked', 'queue_position', 'reminder', 'invite', 'status'];

const TYPE_TO_GROUP = {
  booked: 'booked',
  queue_position: 'queue_position',
  reminder: 'reminder',
  invite: 'invite',
  checked_in: 'status',
  checked_out: 'status',
  cancelled: 'status',
};

export const groupOf = (t) => TYPE_TO_GROUP[t] || t;
export const groupLabel = (g) => (GROUP_META[g] || {}).label || g;
export const groupColor = (g) => (GROUP_META[g] || {}).color || '#9E9E9E';

const orderedGroups = (keys) => [
  ...GROUP_ORDER.filter((g) => keys.includes(g)),
  ...keys.filter((g) => !GROUP_ORDER.includes(g)),
];

/** Merge a `{type: [counts per bucket]}` map into grouped StackedBars groups (types in the same
 *  group are summed element-wise). */
export function typeGroups(byType) {
  if (!byType) return [];
  const merged = {};
  Object.entries(byType).forEach(([t, series]) => {
    const g = groupOf(t);
    if (!merged[g]) merged[g] = (series || []).slice();
    else merged[g] = merged[g].map((v, i) => v + ((series || [])[i] || 0));
  });
  return orderedGroups(Object.keys(merged)).map((g) => ({
    key: g, label: groupLabel(g), color: groupColor(g), series: merged[g],
  }));
}

/** Merge a `{type: {sms, email}}` map into `[{ group, label, sms, email, total }]`, sorted by total. */
export function groupChannelTotals(byTypeChannel) {
  if (!byTypeChannel) return [];
  const merged = {};
  Object.entries(byTypeChannel).forEach(([t, ch]) => {
    const g = groupOf(t);
    merged[g] = merged[g] || { sms: 0, email: 0 };
    merged[g].sms += (ch && ch.sms) || 0;
    merged[g].email += (ch && ch.email) || 0;
  });
  return orderedGroups(Object.keys(merged))
    .map((g) => ({ group: g, label: groupLabel(g), sms: merged[g].sms, email: merged[g].email,
      total: merged[g].sms + merged[g].email }))
    .filter((e) => e.total > 0);
}
